export default __webpack_public_path__ + "static/media/last9.51326bbb.jpg";